module.exports = __webpack_public_path__ + "img/ico-support.52509b3c.svg";